var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Paper, Stack, Typography, useMediaQuery, useTheme, } from "@mui/material";
import { Link } from "react-router-dom";
var SentOffName = function (_a) {
    var name = _a.name;
    return (_jsxs(Box, { component: "span", sx: { display: "inline-flex", alignItems: "center", gap: 0.5 }, children: [_jsx(Box, { component: "span", role: "img", "aria-label": "Red card", sx: {
                    display: "inline-block",
                    width: 9,
                    height: 12,
                    borderRadius: "2px",
                    bgcolor: "#d32f2f",
                } }), _jsx(Typography, { variant: "body2", color: "text.secondary", component: "span", children: name })] }));
};
/**
 * A centered match scoreboard display showing two teams, their scores,
 * and optional scorers. Used for both league matches and intra-squad matches.
 */
export var MatchScoreboard = function (_a) {
    var team1 = _a.team1, team2 = _a.team2, score1 = _a.score1, score2 = _a.score2, _b = _a.scorers1, scorers1 = _b === void 0 ? [] : _b, _c = _a.scorers2, scorers2 = _c === void 0 ? [] : _c, _d = _a.sentOff1, sentOff1 = _d === void 0 ? [] : _d, _e = _a.sentOff2, sentOff2 = _e === void 0 ? [] : _e, topContent = _a.topContent;
    var theme = useTheme();
    var isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    var hasScore = score1 !== null && score1 !== undefined;
    var renderTeamName = function (team) {
        var nameElement = (_jsx(Typography, __assign({ variant: isMobile ? "subtitle1" : "h6", fontWeight: 600, sx: __assign({ textAlign: "center" }, (team.link && {
                textDecoration: "none",
                color: "text.primary",
                "&:hover": { color: "primary.main" },
            })) }, (team.link && { component: Link, to: team.link }), { children: team.name })));
        return nameElement;
    };
    return (_jsx(Paper, { elevation: 0, sx: {
            bgcolor: "grey.50",
            p: { xs: 2, sm: 3 },
            borderRadius: 2,
        }, children: _jsxs(Stack, { spacing: 2, children: [topContent && (_jsx(Box, { display: "flex", justifyContent: "center", children: topContent })), _jsxs(Stack, { direction: "row", justifyContent: "center", alignItems: "center", spacing: { xs: 2, sm: 4 }, children: [_jsxs(Stack, { alignItems: "center", spacing: 1, sx: { flex: 1 }, children: [renderTeamName(team1), hasScore && (_jsx(Typography, { variant: isMobile ? "h4" : "h3", fontWeight: 700, color: "primary.main", children: score1 }))] }), _jsx(Typography, { variant: isMobile ? "h5" : "h4", color: "text.secondary", sx: { px: 1 }, children: hasScore ? "—" : "vs" }), _jsxs(Stack, { alignItems: "center", spacing: 1, sx: { flex: 1 }, children: [renderTeamName(team2), hasScore && (_jsx(Typography, { variant: isMobile ? "h4" : "h3", fontWeight: 700, color: "primary.main", children: score2 }))] })] }), hasScore && (scorers1.length > 0 || scorers2.length > 0) && (_jsxs(Box, { display: "flex", justifyContent: "center", flexWrap: "nowrap", sx: { gap: 3, pt: 1 }, children: [_jsx(Typography, { variant: "body2", textAlign: "right", flex: 1, color: "text.secondary", sx: { maxWidth: "45%" }, children: scorers1.join(", ") }), _jsx(Box, { sx: { width: 40 } }), " ", _jsx(Typography, { variant: "body2", textAlign: "left", flex: 1, color: "text.secondary", sx: { maxWidth: "45%" }, children: scorers2.join(", ") })] })), (sentOff1.length > 0 || sentOff2.length > 0) && (_jsxs(Box, { display: "flex", justifyContent: "center", flexWrap: "nowrap", sx: { gap: 3 }, children: [_jsx(Box, { flex: 1, sx: {
                                maxWidth: "45%",
                                display: "flex",
                                flexWrap: "wrap",
                                gap: 1,
                                justifyContent: "flex-end",
                            }, children: sentOff1.map(function (name, i) { return (_jsx(SentOffName, { name: name }, i)); }) }), _jsx(Box, { sx: { width: 40 } }), _jsx(Box, { flex: 1, sx: {
                                maxWidth: "45%",
                                display: "flex",
                                flexWrap: "wrap",
                                gap: 1,
                                justifyContent: "flex-start",
                            }, children: sentOff2.map(function (name, i) { return (_jsx(SentOffName, { name: name }, i)); }) })] }))] }) }));
};
